import { LoadBalancerFormState } from "./LoadBalancerForm-State";
import {
  errorsList,
  errorsPresent,
  mergeServerValidationErrors,
} from "../../../helpers/ErrorHelper";
import { endOfURL } from "../../../helpers/UrlHelper";
import { isObject } from "../../../helpers/DataHelper";

export default function loadBalancerFormReducer(
  state = LoadBalancerFormState,
  action
) {
  let { data } = { ...state };
  let { validationErrors, name, value, loadBalancer, mode } = action;
  switch (action.type) {
    case "ON-LOAD-BALANCER-FORM-CHANGE":
      data.payload[name] = value;
      buildErrors();
      return { ...state, data };

    case "ON-LOAD-BALANCER-FORM-MODE-CHANGE":
      data.mode = mode;
      buildErrors();
      return { ...state, data };

    case "SET-LOAD-BALANCER-DATA-FOR-UPDATE":
      data.payload = {
        name: loadBalancer.name,
        server_id: loadBalancer.server_id,
        description: loadBalancer.description,
        public_ip_address: loadBalancer.public_ip_address,
        public_ip_class: loadBalancer.public_ip_class,
        public_gateway: loadBalancer.public_gateway,
        public_hardware_address: loadBalancer.public_hardware_address,
        container_name: loadBalancer.container_name,
        // private_ip_address:loadBalancer.private_ip_address,
        // private_ip_class:loadBalancer.private_ip_class,
        // private_gateway:loadBalancer.private_gateway,
        status: loadBalancer.status,
        version: loadBalancer.version,
        // lb_type: loadBalancer.lb_type,
        type: loadBalancer.type,
      };
      buildErrors();
      return { ...state, data };

    case "SET-DEFAULT-LOAD-BALANCER-FORM":
      data = {
        payload: {
          name: ``,
          server_id: "",
          description: ``,
          public_ip_address: ``,
          public_ip_class: ``,
          public_gateway: ``,
          public_hardware_address: ``,
          container_name: "",
          status: ``,
          version: ``,
          // lb_type: `external`,
          type: ``,
        },

        errors: [],
        errorsPresent: false,
        submitted: false,
        dispatchAPI: false,
        mode: endOfURL(),
        message: ``,
      };
      buildErrors();
      return { ...state, data };

    case "CANCEL-LOAD-BALANCER-FORM-DISPATCH":
      data.dispatchAPI = false;
      data.submitted = false;
      buildErrors();
      return { ...state, data };

    case "ON-LOAD-BALANCER-FORM-SUBMIT":
      data.submitted = true;
      buildErrors();
      if (!data.errorsPresent) data.dispatchAPI = true;
      return { ...state, data };

    case "LOAD-BALANCER-FORM-SERVER-VALIDATION-ERRORS":
      validationErrors &&
        isObject(validationErrors) &&
        Object.keys(validationErrors).map(
          (key) =>
            (data.errors[key] = [
              { message: ` - ${validationErrors[key][0]}`.slice(0, -1) },
            ])
        );
      data.dispatchAPI = false;
      return { ...state, data };

    default:
      return state;
  }

  function buildErrors() {
    data.errors = errorsList(errors);
    data.errorsPresent = errorsPresent(errors);
  }

  function errors(field) {
    let { payload, submitted, validationErrors } = data;
    let errors = {};
    Object.keys(payload).map((key) => (errors[key] = []));

    if (submitted) {
      if (field === `name`) {
        if (!_(field)) newError(field, 0, `This is required field`);
      }

      if (field === `server_id`) {
        if (!_(field)) newError(field, 0, `This is required field`);
      }

      if (field === `status`) {
        if (!_(field)) newError(field, 0, `This is required field`);
      }
      if (field === `version`) {
        if (!_(field)) newError(field, 0, `This is required field`);
      }

      if (field === `public_ip_address`) {
        if (!_(field)) newError(field, 0, `This is required field`);
      }

      if (field === `public_ip_class`) {
        if (!_(field)) newError(field, 0, `This is required field`);
      }

      if (field === `public_gateway`) {
        if (!_(field)) newError(field, 0, `This is required field`);
      }

      if (field === `public_hardware_address`) {
        if (!_(field)) newError(field, 0, `This is required field`);
      }

      if (field === `container_name`) {
        if (!_(field)) newError(field, 0, `This is required field`);
      }

      /*if (field === `lb_type`) {
                if (!_(field)) newError(field, 0, `This is required field`)
            }*/
      if (field === `type`) {
        if (!_(field)) newError(field, 0, `This is required field`);
      }
    }

    errors = mergeServerValidationErrors(errors, validationErrors);

    return field ? errors[field] : errors;

    function newError(field, step, message) {
      errors && errors[field].push({ step, message });
    }

    function _(field) {
      return data.payload[field];
    }
  }
}
